import styled from "styled-components";

/** Wrapper for inline shadow-map WebGL demo (Home, `/3D`). */
export const ProjectsShadowWrap = styled.div`
  .projects-shadow-stage {
    border: 1px solid rgba(148, 163, 184, 0.2);
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.45);
    overflow: hidden;
    background: #000;
  }

  .projects-shadow-stage--fallback {
    min-height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem 1.25rem;
    border: 1px dashed rgba(148, 163, 184, 0.28);
    background: rgba(15, 23, 42, 0.35);
  }
`;

export const CarouselContainer = styled.div`
  padding: 20px;

  .rec-carousel button,
  .rec-pagination {
    display: none !important;
  }

  .rec-item-wrapper {
    width: 100% !important;
  }

  .rec-carousel-item {
    border: solid 10px transparent;
    border-radius: 12px;
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.02);
    }
  }

  .project-name {
    position: absolute;
    top: 50%;
    left: 20px;
    right: 20px;
    transform: translateY(-50%);
    font-size: 1.5rem;
    font-weight: 700;
    color: white;
    text-align: center;
    z-index: 10;
    text-transform: uppercase;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8), 0 0 10px rgba(0, 0, 0, 0.5);
    letter-spacing: 1px;
    word-wrap: break-word;
    overflow-wrap: break-word;
    hyphens: auto;
    
    &::after {
      content: '';
      position: absolute;
      bottom: -4px;
      left: 0;
      right: 0;
      height: 2px;
      background: linear-gradient(90deg, #ffffff, #ffffff);
      transform: scaleX(0);
      transition: transform 0.3s ease;
    }
    
    @media (max-width: 768px) {
      font-size: 1rem;
      left: 10px;
      right: 10px;
      letter-spacing: 0.5px;
    }
    
    @media (max-width: 480px) {
      font-size: 0.875rem;
      left: 8px;
      right: 8px;
      letter-spacing: 0.25px;
    }
  }
`;

export const SlideItem = styled.div`
  display: flex;
  height: 60vh;
  width: 100%;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.02);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.4);
    
    .project-name::after {
      transform: scaleX(1);
    }
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.3) 0%,
      rgba(0, 0, 0, 0.1) 40%,
      rgba(0, 0, 0, 0.1) 60%,
      rgba(0, 0, 0, 0.7) 100%
    );
    z-index: 1;
  }

  img {
    border-radius: 12px;
    opacity: 0.9;
    width: 302px;
    object-fit: cover;
    transition: all 0.3s ease;

    @media (max-width: 768px) {
      width: 100%;
    }
  }

  &:hover img {
    opacity: 1;
    transform: scale(1.05);
  }

  .view-details-button {
    color: white;
    font-size: 12px;
    font-weight: 600;
    width: 100%;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 0;
    background: linear-gradient(135deg, 
      rgba(0, 0, 0, 0.9) 0%, 
      rgba(20, 20, 35, 0.95) 100%);
    backdrop-filter: blur(15px);
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
    padding: 12px 0;
    transition: all 0.3s ease;
    z-index: 10;
    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.4);
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }

  &:hover .view-details-button {
    background: linear-gradient(135deg, 
      rgba(0, 126, 238, 0.9) 0%, 
      rgba(139, 92, 246, 0.9) 100%);
    box-shadow: 0 -8px 20px rgba(0, 126, 238, 0.4);
  }

  .text-gradient-secondary {
    background: linear-gradient(135deg, #ffffff 0%, #e0f2fe 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    transition: all 0.3s ease;
    font-size: 13px;
  }

  &:hover .text-gradient-secondary {
    background: linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    transform: scale(1.05);
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  }

  .disabled {
    cursor: no-drop;
    background: #ccc;
    opacity: 0.5;
  }

  p {
    margin-bottom: 0;
  }
`;

export const Tabs = styled.div`
  ul {
    list-style: none;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding-left: 0;
    margin: 0;
    gap: 8px;

    li {
      margin: 0;
      background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
      backdrop-filter: blur(10px);
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 20px;
      padding: 8px 16px;
      color: #ffffff;
      cursor: pointer;
      font-size: 14px;
      font-weight: 600;
      transition: all 0.3s ease;
      white-space: nowrap;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);

      &:hover {
        background: linear-gradient(135deg, rgba(0, 126, 238, 0.8) 0%, rgba(139, 92, 246, 0.8) 100%);
        color: #ffffff;
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(0, 126, 238, 0.3);
        border-color: rgba(0, 126, 238, 0.4);
      }

      @media (max-width: 768px) {
        padding: 6px 12px;
        font-size: 12px;
        border-radius: 16px;
        margin: 2px;
      }

      @media (max-width: 480px) {
        padding: 5px 10px;
        font-size: 11px;
        border-radius: 14px;
        margin: 1px;
      }
    }

    .active {
      background: linear-gradient(135deg, rgba(0, 126, 238, 0.9) 0%, rgba(139, 92, 246, 0.9) 100%);
      color: #ffffff;
      box-shadow: 0 8px 20px rgba(0, 126, 238, 0.4);
      border-color: rgba(0, 126, 238, 0.5);
      transform: translateY(-1px);
    }
  }

  @media (max-width: 768px) {
    ul {
      gap: 4px;
      padding: 0 10px;
    }
  }

  @media (max-width: 480px) {
    ul {
      gap: 2px;
      padding: 0 5px;
    }
  }
`;

export const ProjectGrid = styled.div`
  padding: 0;
  display: flex;
  align-items: center;
  background: #ffffff;
  border: 1px solid #e2e2e2;
  box-shadow: 0px 12px 32px rgba(0, 0, 0, 0.1);
  border-radius: 24px;
  flex-direction: column;
  display: flex;
  margin-bottom: 26px;

  img {
    border-top-left-radius: 24px;
    border-top-right-radius: 24px;
  }

  p {
    font-weight: 600;
  }

  &:hover {
    transform: scale(1.02);
  }

  .disabled {
    cursor: no-drop;
    opacity: 0.7;
  }
`;

export const GalleryContainer = styled.div`
  .gallery-custom-wrapper {
    display: flex;
    flex-wrap: wrap;

    a {
      flex: 1;
      margin: 16px 0;
      /* border: solid 1px #eee;
      border-radius: 12px; */
      margin: 10px;
    }
  }
`;

export const ImageRotation = styled.div`
  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;
